import Vue from 'vue'
import App from './App.vue'
import globalComponents from './plugins/globalComponents'
import router from './router'
import PortalVue from 'portal-vue'

// Set up Pace for XHR requests
import '@/utils/pace/setUpPace'

Vue.config.productionTip = false

Vue.use(PortalVue)
Vue.use(globalComponents)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
